

import VesselMonitoringSingleBay from "./VesselMonitoringSingleBay.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    VesselMonitoringSingleBay
  },
  props: {
    vesselHatch: { type: Object
    },
    minDeckTiersNo:{default: 0},
    minHoldTiersNo:{default: 0},
  },
  mounted() {
  },
  computed: {
    ...mapGetters(["getVesselMonitoringData"]),
    
    vesselMonitoringData() {
      return this.getVesselMonitoringData;
    }
  },
}
